module.exports = __webpack_public_path__ + "static/media/google-button.949f5984.svg";